export const RpcUrl = " https://bsc-dataseed.binance.org/";
export const Zepcoin_Address = "0x0Af7aeE626B2641cb1c91c4D42F903D37D88148F";
export const Ico_Address = "0xd68a4dde353e88f99f45379899698b5a8d6dca5f";
export const Usdt_Address = "0x55d398326f99059fF775485246999027B3197955";
export const Busd_Address = "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56";
export const Zepcoin_Abi = require("../contract/Zepcoin.json");
export const Usdt_Abi = require("../contract/usdt-abi.json");
export const Ico_Abi = require("../contract/ico-abi.json");
export const Busd_Abi = require("../contract/Busd.json");
